export default __webpack_public_path__ + "static/media/Dinosaur_02.b49c41e2.png";